<template>
  <div class="search">
    <b-card>
    <b-row>
      <b-col cols="6">
        <b-input-group :prepend="total_count.toString()" class="mt-4">
          <b-form-input
            size="md"
            @keyup.enter.native="firstOnSearch"
            type="text"
            v-model.trim="query"
            spellcheck="false"
            list="search-list-id"
          ></b-form-input>
          <b-input-group-append>
            <b-btn size="md" variant="secondary" v-on:click="firstOnSearch"
              >Search</b-btn
            >
          </b-input-group-append>
          <b-form-datalist
            id="search-list-id"
            class="bg-warning"
            :options="search_attrs"
          ></b-form-datalist>
        </b-input-group>
      </b-col>
      <b-col cols="6" class="bg-secondary h-100">
        <div
          v-b-popover.hover.top="
            `use the buttons to page through the database entries.  Each button retrieves a set of ${pageSize} citations (out of the total:${citation_count}) for use below`
          "
          title="Database Pages"
        >
          <b-pagination
            size="md"
            class="m-4"
            v-model="pageNum"
            :total-rows="total_count"
            :per-page="pageSize"
            first-text="First"
            prev-text="Prev"
            next-text="Next"
            last-text="Last"
            limit="9"
            @change="changePage"
          ></b-pagination> 
        </div>
      </b-col>
    </b-row>
    <b-alert :show="isSearching" variant="warning" class="mt-5">
      <p>Searching Database. Please be patient</p>
      <b-progress
        :value="100"
        variant="info"
        :animated="isSearching"
        class="mb-3"
      ></b-progress>
    </b-alert>
    </b-card>
   <b-card>
      <b-card v-for="cite in cites" :key="cite.doi" class="secondary m-3">
        <b-row>
        <b-col cols="10" class="text-left text-secondary">
          <h5 class="text-left" variant="secondary">
            {{ `${cite.journal_abbr} (${cite.year}) ${cite.voliss}, ${cite.pages}` }}
          </h5>
          <h6 class="text-left">{{ cite.title }}</h6>
          <p class="text-left">{{ cite.author }}</p>
          <p class="text-left">{{ cite.abstract }}</p>
          <a :href="`https://dx.doi.org/${cite.doi}`" target="_blank" >
            DOI:{{cite.doi}}
          </a>
        </b-col>
        <b-col cols="2">
          <b-list-group>
            <b-list-group-item variant="info">
              <a :href="`/ThermoML/${cite.doi}.html`" target="_blank">
                Details
              </a>
            </b-list-group-item>
            <b-list-group-item>
              <a :href="`/ThermoML/${cite.doi}.json`" target="_blank"> JSON </a>
            </b-list-group-item>
            <b-list-group-item>
              <a :href="`/ThermoML/${cite.doi}.xml`" target="_blank">
                ThermoML</a
              >
            </b-list-group-item>
          </b-list-group>
        </b-col>
        </b-row>
        <b-row>
          <b-col cols=3>
            <b-card title="Compounds">
            <b-list-group>
            <b-list-group-item v-for="cmpd in cite.compounds" :key="cmpd.id" variant="warning">
                {{cmpd.sCommonName[0]}}
            </b-list-group-item>
          </b-list-group>
            </b-card>
          </b-col>

          <b-col cols=9>
            <h4> Data Summary </h4>
            <div v-for="dset_type in Object.keys(cite.data_summary)" :key="dset_type.id">
              <property
               :dset_type="dset_type"
               :group_property="cite.data_summary[dset_type]"
             />
            </div>
         </b-col>
        </b-row>
 
      </b-card>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import Property from "@/components/Property.vue";
export default {
  components: { Property },
  name: "TMLSearch",

  data: function () {
    return {
      isSearching: false,
      accumulate: false,
      pageNum: 1,
      search_ready: false,
      search_prepend: "",
      pageSize: 25,
      citations: [],
      total_count: 0,
      query: "",
      search_attrs: [
      '"guanidine hydrochloride"', 
      '"PJJJBBJSCAKJQF-UHFFFAOYSA-N"','Chirico','Diky','Bazyleva','Paulechka', 'Magee']
    };
  },
  computed: {
    citation_count() {
      return this.citations.length;
    },
    cites(){
      let cites = this.citations.map((cite) => {
          let voliss = cite.Citation.sIDNum ? 
                `${cite.Citation.sVol}.${cite.Citation.sIDNum}` :
                cite.Citation.sVol; 
          
          return {
            title: cite.Citation.sTitle,
            abstract: cite.Citation.sAbstract,
            doi: cite.Citation.sDOI,
            pages: cite.Citation.sPage,
            author: cite.Citation.sAuthor.join(','),
            year: cite.Citation.yrPubYr,
            voliss: voliss, 
            journal_abbr: cite.Citation.sPubName, 
            data_summary: cite.data_summary,
            compounds: cite.Compound
          }
      });
      return cites
    }
  },

  methods: {
    changePage(page) {
      let vm = this;
      vm.pageNum = page;
      vm.onSearch();
    },
    firstOnSearch() {
      let vm = this;
      vm.pageNum = 1;
      vm.onSearch();
    },
    onSearch() {
      let vm = this;
      let query_input = vm.query
      if ( /&/.test(vm.query) ) {
        alert("& conflicts with url search parameter; interpretting as AND")
        query_input = query_input.replaceAll(/&+/g," AND ")
        vm.query=query_input
        return
      }
      query_input = /\S/.test(vm.query) ? vm.query : '*:*' 
      let query = `type:TRCTml4 AND (${query_input})`
      let pageNum = vm.pageNum;
      let pageSize = vm.pageSize;
      vm.isSearching = true;
      vm.search_ready = false;
      vm.citations.splice(0);
      let url = `${process.env.VUE_APP_API_ENDPOINT}/objects?query=${query}&pageNum=${
        pageNum - 1
      }&pageSize=${pageSize}&sortFields=&requestContext={"Citation":true,"data_summary":true,"Compound":true}`;
      axios
        .get(url)
        .then((response) => {
          vm.total_count = response.data.size;
          vm.isSearching = false;
          vm.search_ready = true;
          vm.citations = response.data.results.map((result) => result.content);
        })
        .catch((error) => {
          alert("Search failed: please contact trcinfo@nist.gov with sufficient details if this error is unexpected")
          console.log(error);
          vm.isSearching = false;
          vm.search_ready = true;
        });
      //   vm.fetchCitations(params).then(() => {
      //   });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #000000 !important;
}
</style>